import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "countedQuantity",
    "quantityVariance",
    "countedWeight",
    "weightVariance"
  ]

  static values = {
    systemQuantity: Number,
    systemWeight: Number
  }

  connect() {
    this.update()
  }

  update() {
    this.updateQuantityVariance()
    this.updateWeightVariance()
  }

  updateQuantityVariance() {
    if (!this.hasCountedQuantityTarget || !this.hasQuantityVarianceTarget) return

    const variance = this.parseNumber(this.countedQuantityTarget.value) - this.systemQuantityValue
    this.renderVariance(this.quantityVarianceTarget, variance)
  }

  updateWeightVariance() {
    if (!this.hasCountedWeightTarget || !this.hasWeightVarianceTarget) return

    const variance = this.parseNumber(this.countedWeightTarget.value) - this.systemWeightValue
    this.renderVariance(this.weightVarianceTarget, variance)
  }

  renderVariance(element, variance) {
    element.textContent = this.formatNumber(variance)
    element.classList.remove("fg-body", "fg-success", "fg-danger")

    if (variance > 0) {
      element.classList.add("fg-success")
    } else if (variance < 0) {
      element.classList.add("fg-danger")
    } else {
      element.classList.add("fg-body")
    }
  }

  parseNumber(value) {
    const parsed = Number.parseFloat(value)
    return Number.isFinite(parsed) ? parsed : 0
  }

  formatNumber(value) {
    if (Object.is(value, -0)) value = 0

    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 4
    }).format(value)
  }
}
